import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Location } from '@angular/common';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Editor, Toolbar } from 'ngx-editor';
import { takeUntil } from 'rxjs';
import { LoginModel } from 'src/app/models/legacy';
import { UserProfileModel } from 'src/app/models/repository/user-profile.model';
import { ImageCropperPopupComponent } from 'src/app/popups/image-cropper-popup/image-cropper-popup.component';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { EventsEmitter } from 'src/app/shared/event-emitter/EventEmitter';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Schema } from 'prosemirror-model';
import { FormUtilsService } from 'src/app/services/formUtils.service';

@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent             
  extends BaseUnsubscribeComponent
  implements OnInit
{
  public userProfileForm: FormGroup;

  public isLoader = false;
  public closeResult = '';

  public responseSuccess: any = null;
  public responseError: any = null;

  public submitted = false;
  private file: File;
  public user: LoginModel;
  public userProfleModel: UserProfileModel;
  @ViewChild('fileInput') el: ElementRef;
  imageUrl: any = 'assets/images/user.png';

  @Input() public isUseBuiltInSave = true;


  public config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
      ],
      image: [
        ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
        ['float', ['floatLeft', 'floatRight', 'floatNone']],
        ['remove', ['removeMedia']]
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear'
          ]
        ]
      ]
    },
    height: '500px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['customButtons', ['testBtn']],
      ['view', ['fullscreen', 'codeview', 'help']]
    ],
    fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36', '44', '56', '64', '76', '84', '96'],
    fontNames: ['Arial', 'Times New Roman', 'Inter', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times', 'MangCau', 'BayBuomHep', 'BaiSau', 'BaiHoc', 'CoDien', 'BucThu', 'KeChuyen', 'MayChu', 'ThoiDai', 'ThuPhap-Ivy', 'ThuPhap-ThienAn'],
   
    codeviewFilter: true,
    codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true
  };
  countries: any[] = [];

  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly eventEmitter: EventsEmitter,
    private readonly location: Location,
    private toastService: ToastService,
    private readonly modalService: NgbModal,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private formUtilsService: FormUtilsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLoader = true;
    this.loadUser();
    this.loadProfile();

    this.userProfileForm = this.formBuilder.group({
      userName: [{ value: '', disabled: true }],
      password: [{ value: '', disabled: true }],
      confirmPassword: [{ value: '', disabled: true }],
      isPasswordChanged: [false],
      gender: ['dr', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      title: [''],
      email: ['', [Validators.required]],
      degree: [''],
      accreditation: ['', [Validators.required]],
      replyToEmailAddress: ['', []],
      //organisation: ['', [Validators.required]],
      //organisationID: [''],
      //dicomDeviceId: [0],
      //licenseNumber: [''],
      suffix: [''],
      //websiteUrl: [''],
      //address: ['', [Validators.required]],
      //stateName: ['', [Validators.required]],
      //countryName: ['', [Validators.required]],
      //postCode: ['', [Validators.required]],
      //phoneNumber: ['', [Validators.required]],
      //phoneNumberCountryCode: ['', [Validators.required]],
      //phoneNumber2: [''],
      //phoneNumber2CountryCode: [''],
      //city: ['', [Validators.required]],
      //contactNumber1: [''],
      //contactNumber1CountryCode: [''],
      //contactNumber2: [''],
      //contactNumber2CountryCode: [''],
      emailSignature: [''],
    });

    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.countries = responseData;

          if (this.countries && this.countries?.length > 0) {
          }
        }
      }
    });
    setTimeout(() => {
      document.querySelectorAll("[data-toggle='dropdown']").forEach((el) => {
        el.setAttribute("data-bs-toggle", "dropdown");
      });
      document.querySelectorAll("[data-dismiss='modal']").forEach((el) => {
        el.setAttribute("data-bs-dismiss", "modal");
        el.setAttribute("class", "btn-close");
        el.textContent = ''
      });
      document.querySelectorAll(".modal-header").forEach((el) => {
        el.setAttribute("dir", "rtl");
      });
    },400)
   
  }

  // make sure to destory the editor
  override ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public loadUser(): void {
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
      }
    });
  }

  uploadFile(event: Event) {
    const modalRef = this.modalService.open(ImageCropperPopupComponent, {
      ariaLabelledBy: 'ImageCropperId',
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static',
    });

    const data = {
      file: event,
      from: 'imageFile',
      aspectRatio: 4 / 4,
      cropperMinWidth: 500,
      cropperMinHeight: 500,
      cropperMaxWidth: 500,
      cropperMaxHeight: 500,
      roundCropper: false,
      containWithinAspectRatio: false,
      maintainAspectRatio: true,
      format: 'png',
      alignImage: 'left',
    };

    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        const data = result;
        this.imageUrl = data.croppedImageBase64;
        this.file = data.croppedImageFile;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public loadProfile(): void {
    if (this.user) {
      this.userService
        .getUserProfile()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (response) => {
            if (response) {
              this.userProfleModel = response;
              if (this.userProfleModel.image) {
                this.imageUrl = this.userProfleModel.image;
              }
              const formData = {
                userName: this.userProfleModel?.userName,
                firstName: this.userProfleModel?.firstName,
                lastName: this.userProfleModel?.lastName,
                title: this.userProfleModel?.title,
                email: this.userProfleModel?.email,
                degree: this.userProfleModel?.degree,
                accreditation: this.userProfleModel?.accreditation,
                replyToEmailAddress: this.userProfleModel?.replyToEmailAddress,
                //organisation: this.userProfleModel?.organisation,
                //organisationID: this.userProfleModel?.organisationID,
                //dicomDeviceId: this.userProfleModel?.dicomDeviceId,
                //licenseNumber: this.userProfleModel?.licenseNumber,
                suffix: this.userProfleModel?.suffix,
                /*websiteUrl: this.userProfleModel?.websiteUrl,*/
                //address: this.userProfleModel?.address,
                //stateName: this.userProfleModel?.stateName,
                //countryName: this.userProfleModel?.countryName,
                //postCode: this.userProfleModel?.postCode,
                //phoneNumber: this.userProfleModel?.phoneNumber,
                //phoneNumberCountryCode: this.userProfleModel?.phoneNumberCountryCode,
                //phoneNumber2: this.userProfleModel?.phoneNumber2,
                //phoneNumber2CountryCode: this.userProfleModel?.phoneNumber2CountryCode,
                //suburb: this.userProfleModel?.suburb,
                //city: this.userProfleModel?.city,
                //contactNumber1: this.userProfleModel?.contactNumber1,
                //contactNumber1CountryCode: this.userProfleModel?.contactNumber1CountryCode,
                //contactNumber2: this.userProfleModel?.contactNumber2,
                //contactNumber2CountryCode: this.userProfleModel?.contactNumber2CountryCode,
                emailSignature: this.userProfleModel?.emailSignature,
                file: '',
              };
              this.userProfileForm.patchValue(formData);
            }

            this.isLoader = false;
          },
          (error) => {
            if (error.status === 401) {
              this.authService.logout();
              window.location.href = '/';
            }
          }
        );
    }
  }
 
  public formSubmit(): void {
    this.submitted = true;
    if (this.userProfileForm.invalid) {
      return;
    }

    let formData = new FormData();
    const form = this.userProfileForm.value;
    for (var key in form) {
      formData.append(key, form[key] === null ? '' : form[key]);
    }
    if (this.file) {
      formData.append('imageFile', this.file);
    }
    this.userService
      .postUserProfile(formData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          this.eventEmitter.emitTopBannerEvent(response);
          if (response) {
            this.authService.setUserProfileStatus(response.hasBusinessProfile);

            // Update user display info in top banner with the new profile information
            this.authService.updateUserDisplayInfo(response.firstName, response.lastName, response.email);

            this.toastService.success('Profile has been updated');
            this.location.back();
          }
        },
        (errorResponse: Error) => {
          this.submitted = false;
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (errorData?.status === 401 || errorData?.status === 500) {
              this.toastService.success(errorData.error.message);
            }

            if (errorData?.status === 400) {
              let errorMessages = '';
              if (errorData.error instanceof Array) {
                errorData.error.forEach((value: { message: string }) => {
                  errorMessages += value.message + '\n';
                });
              } else {
                errorMessages = errorData.error.message;
              }
              this.toastService.success(errorMessages);
            }
          }
        }
      );
  }
  isFormValid(): boolean {
    this.submitted = true;
    this.formUtilsService.MarkFormFieldsTouched(this.userProfileForm);
    return !this.userProfileForm.invalid;
  }
  getFormData(): FormData | null {
    this.submitted = true;
    if (this.userProfileForm.invalid) {
      return null;
    }

    const formData = new FormData();
    const form = this.userProfileForm.value;


    for (const key in form) {      
      formData.append(key, form[key] === null ? '' : form[key]);
    }

    if (this.file) {
      formData.append('imageFile', this.file);
    }

    return formData;
  }

    
}
